import {
  CATEGORY_CONFIG,
  CHALLENGE_CATEGORY,
  OfferingType,
} from '../../../../../../components/ContractModal/PackageCategoryCard/utils';

/**
 * Build one row per Inside Sales category, carrying whatever offering is assigned to it.
 *
 * A category holds one offering per coach. A package and a challenge can only both carry the same
 * category if the data was written outside this flow, so the package wins that tie — it is the
 * pre-existing source of truth and a stale contract should not hide it.
 *
 * @param {object} params The assigned offerings.
 * @param {Array<{pkg: object, product: object}>} [params.categorizedPackages] Packages holding a category.
 * @param {Array<object>} [params.categorizedChallenges] Challenge contracts holding a category.
 * @returns {Array<object>} One row per category, in CATEGORY_CONFIG order.
 */
const getOfferingRows = ({ categorizedPackages = [], categorizedChallenges = [] } = {}) => (
  Object.entries(CATEGORY_CONFIG).map(([category, config]) => {
    const packageEntry = categorizedPackages.find(({ pkg }) => pkg?.category === category);
    // A challenge only ever belongs to the low ticket row; one assigned anywhere else is bad data
    // and is ignored rather than rendered as an offering that flow cannot produce.
    const challenge = (packageEntry || category !== CHALLENGE_CATEGORY)
      ? null
      : categorizedChallenges.find((contract) => contract?.category === category);

    let offering = null;
    if (packageEntry) {
      offering = {
        type: OfferingType.PACKAGE,
        doc: packageEntry.pkg,
        name: packageEntry.pkg.name,
        subTitle: packageEntry.product?.name || '',
      };
    } else if (challenge) {
      offering = {
        type: OfferingType.CHALLENGE,
        doc: challenge,
        name: challenge.name,
        subTitle: '',
      };
    }

    return {
      id: category,
      category,
      label: config.label,
      Tag: config.Tag,
      canHoldChallenge: category === CHALLENGE_CATEGORY,
      offering,
    };
  })
);

export {
  getOfferingRows,
};
